import { render, staticRenderFns } from "./TifMapaIndex.vue?vue&type=template&id=6b019bfe"
import script from "./TifMapaIndex.vue?vue&type=script&lang=js"
export * from "./TifMapaIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports